/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */

import { Link } from "react-router-dom";
import SkipImage from "../../../assets/images/person-image.PNG";
import { useTranslation } from 'react-i18next';
import React from "react";

import "../../../assets/stylesheet/change-homepage.css";
import { CONFIG_MASTER_ENUM } from "../../../constants/constant";
import {
  getMainModuleConfiguration
} from "../../../store/Checkin/moduleConfigurationSlice";

import { getConfigurationCode, getStepMaster } from "../../../helpers/commonHelper";

// import { useSelector } from "react-redux";

import { STEP_MASTER_ENUM } from "../../../constants/constant";
import i18n from "i18next";
import { postStageDetails } from "../../../store/stageSlice";
import { getPassportScanData } from "../../../store/Checkin/Scan/scanPassportSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  getParametersFromLocalStorage,
  homePageHandler,
} from "../../../helpers/commonHelper";
  const token = getParametersFromLocalStorage("token");
const SkipModal = ({ closeModal, skipHandler,navigateUrl }) => {
  const stepMaster = useSelector((state) => getMainModuleConfiguration(state));

  const stepUpsellPage = getStepMaster(
    stepMaster,
    STEP_MASTER_ENUM.UPSELL_PAGE
  );
  const configs = stepUpsellPage?.configs;
  const skipImage = getConfigurationCode(//ss
    configs,
    CONFIG_MASTER_ENUM.SKIP_IMAGE
  );
  const { t } = useTranslation();

   const userData = useSelector(getPassportScanData);

const dispatch = useDispatch();
  const stageReporting=function()
  {
  
     try {
                      const data = {
                        PMSConfirmationNo: userData?.pmsConfirmationNo,
                        IsSuccess: true,
                        StepCode: STEP_MASTER_ENUM.UPSELL_PAGE,
                        SubStep: "Upsell",
                        AppType: "kiosk",
                        SuccessMessage: "Skipped",
                        FailureReason: "Skipped",
                      };
                      dispatch(postStageDetails({ data, token }));
                    } catch (error) {
                      console.error("Error posting stage details skip:", error);
                    }
  }

  return (
    <div
      className="modal"
    >
      <div className="modal-dialog modal-lg modal-top">
        <div className="modal-content modal-bg">
          <div className="modal-body">
            <div className="text-center">
             
              <div>
                {
                   skipImage === true &&
                   <>
                    <img src={SkipImage} className="w-110" />
                   </>
                 
                }
              </div> 
          
              <div className="mt-30">
                <h6>
                  {t("Do you want to skip this step without")} <br></br>{t("selecting packages?")}
                </h6>
              </div>
            </div>
            <div className="text-center mt-30">
              <button id="btn-skipmodal-no"
                className="btn modal-no-btn"
                data-bs-dismiss="modal"
                onClick={closeModal}
              >
                {t("No")}
              </button>
              <Link to={navigateUrl}>
                <button id="btn-skipmodal-yes"
                  className="btn modal-yes-btn bg-transperent"
                  onClick={() => {
                    stageReporting();
                    skipHandler();
                  }}
                >
                  {t("Yes")}
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkipModal;
